import { PartPropertyGridController } from './controller'
import template from './index.html'

PartPropertyGridDirective.vsName = 'partPropertyGrid'
PartPropertyGridDirective.vsNgType = 'directive'

PartPropertyGridDirective.$inject = []
function PartPropertyGridDirective() {
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    scope: {
      parts: '='
    },
    controller: PartPropertyGridController,
    controllerAs: 'ctrl',
    bindToController: true
  }
}

export default PartPropertyGridDirective